import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'
import ScheduleView from '@/views/ScheduleView.vue'
import EmptyView from '@/views/EmptyView.vue'

import { Message } from 'element-ui'
import store from '@/store/index'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    component: HomeView,
    redirect: '/middleware',
    children: [
      {
        path: '/login',
        component: () => import(/* webpackChunkName: "login" */ '@/views/login.vue'),
      },
      {
        path: '/middleware',
        component: () => import(/* webpackChunkName: "Middleware" */ '@/views/middleware.vue'),
      },
      {
        path: '/homeIndex',
        meta: {
          needAuth: true,
        },
        component: () => import(/* webpackChunkName: "HomeIndex" */ '@/views/HomeIndex.vue'),
      },
      {
        path: '/scheduling',
        redirect: '/scheduling/testInformation',
        component: ScheduleView,
        children: [
          // 注意事项
          {
            path: '/scheduling/testInformation',
            meta: {
              title: 'Program Information',
            },
            component: () => import(/* webpackChunkName: "Attention" */ '@/views/schedule/attention.vue'),
          },
          // 隐私确认
          {
            path: '/scheduling/agreement',
            meta: {
              title: 'Policy Agreement',
            },
            component: () => import(/* webpackChunkName: "PrivacyConfirm" */ '@/views/schedule/privacyConfirm.vue'),
          },
          // 查找考试中心
          {
            path: '/scheduling/scheduleLocation',
            meta: {
              title: 'Date & location Selection',
            },
            component: () => import(/* webpackChunkName: "SearchTestCenter" */ '@/views/schedule/searchTestCenter.vue'),
          },
          // 预约
          {
            path: '/scheduling/scheduleTestcenter',
            meta: {
              title: 'Test Center Selection',
            },
            component: () => import(/* webpackChunkName: "Appointment" */ '@/views/schedule/appointment.vue'),
          },
          // 完善信息
          {
            path: '/scheduling/candidateProfile',
            meta: {
              title: 'Additional Demographic Information',
            },
            component: () => import(/* webpackChunkName: "PerfectInfo" */ '@/views/schedule/PerfectInfo.vue'),
          },
          // 确认信息
          {
            path: '/scheduling/confirmation',
            meta: {
              title: 'Appointment Information',
            },
            component: () => import(/* webpackChunkName: "ConfirmInfo" */ '@/views/schedule/confirmInfo.vue'),
          },
          // 预约线上/改期线上
          {
            path: '/scheduling/scheduleProctor',
            meta: {
              title: 'Date & time Selection',
            },
            component: () => import(/* webpackChunkName: "AppointOnline" */ '@/views/schedule/appointOnline.vue'),
          },
        ],
      },
      {
        path: '/scheduling/cancelappointment',
        redirect: '/scheduling/cancelappointment/verification',
        component: EmptyView,
        children: [
          // 资格码查询
          {
            path: '/scheduling/appointmentsearch',
            meta: {
              title: 'Appointment Search',
            },
            component: () => import(/* webpackChunkName: "appointmentsearch" */ '@/views/schedule/eligibilityCodeSearch.vue'),
          },
          // 取消预约
          {
            path: '/scheduling/cancelappointment/verification',
            meta: {
              title: 'Cancel Appointment Summary',
            },
            component: () => import(/* webpackChunkName: "CancelAppoint" */ '@/views/schedule/cancelAppoint.vue'),
          },
        ],
      },
    ],
  },
  // 成绩单
  {
    path: '/scheduling/cancelappointment/reportCard',
    meta: {
      needAuth: true,
      titleCustom: true,
      title: 'Prometric - Score Report',
    },
    component: () => import(/* webpackChunkName: "ReportCard" */ '@/views/schedule/reportCard.vue'),
  },
  // 确认信
  {
    path: '/confirmation/:confnum',
    meta: {
      needAuth: false,
      titleCustom: true,
      title: 'Confirmation Letter',
    },
    component: () => import(/* webpackChunkName: "ConfirmLetter" */ '@/views/schedule/confirmLetter.vue'),
  },
  // 人脸识别结果H5
  {
    path: '/h5faceid',
    meta: {
      needAuth: false,
      title: 'Face Result',
    },
    component: () => import(/* webpackChunkName: "FaceResult" */ '@/views/schedule/faceH5Result.vue'),
  },
  // 人脸识别结果PC
  {
    path: '/faceid',
    meta: {
      needAuth: false,
      title: 'Face Result',
    },
    component: () => import(/* webpackChunkName: "FaceResult" */ '@/views/schedule/faceResult.vue'),
  },
  {
    path: '*',
    meta: {
      needAuth: false,
      title: 'NotFound',
    },
    component: () => import(/* webpackChunkName: "NotFound" */ '@/views/404.vue'),
  },
]

const router = new VueRouter({
  mode: 'history',
  routes,
})

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = 'ProScheduler - ' + to.meta.title
    if (to.meta.titleCustom === true) document.title = to.meta.title
  }
  if (!sessionStorage.getItem('token')) {
    if (to?.meta?.needAuth === true) {
      next('/login')
    } else {
      next()
    }
  } else {
    next()
  }
  next()
})

export default router
